import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useBentoGlow } from '../hooks/useScrollReveal';
import '../styles/Hero.css';

const fadeUp = (delay = 0) => ({
    initial: { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});

const Hero = () => {
    const glowRef = useBentoGlow();
    const [time, setTime] = useState('');

    useEffect(() => {
        const tick = () => setTime(
            new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta', hour12: false })
        );
        tick();
        const id = setInterval(tick, 30000);
        return () => clearInterval(id);
    }, []);

    const techIcons = [
        { src: '/react.webp', alt: 'React' },
        { src: '/js.webp', alt: 'JavaScript' },
        { src: '/node.webp', alt: 'Node.js' },
        { src: '/mongo.webp', alt: 'MongoDB' },
        { src: '/html.webp', alt: 'HTML' },
        { src: '/git.webp', alt: 'Git' },
    ];

    return (
        <section id="hero" className="hero">
            <div className="container" ref={glowRef}>
                <div className="hero-grid">
                    {/* Main Card */}
                    <motion.div className="bento-card hero-main" {...fadeUp(0.3)}>
                        <div className="hero-status-badge">
                            <span className="status-dot" />
                            <span className="mono" style={{ fontSize: '0.75rem', color: 'var(--text-accent)' }}>
                                Available for opportunities
                            </span>
                        </div>

                        <h1 className="hero-name">
                            Hi, I'm{' '}
                            <span className="gradient-text">Nanda</span>
                        </h1>

                        <p className="hero-tagline">
                            Full Stack Developer & Informatics Student — crafting innovative
                            digital solutions with modern technologies.
                        </p>

                        <div className="hero-actions">
                            <a href="#projects" className="btn primary">
                                View Projects <span className="arrow">→</span>
                            </a>
                            <a href="#contact" className="btn secondary">
                                Get In Touch <span className="arrow">↗</span>
                            </a>
                        </div>
                    </motion.div>

                    {/* Photo Card */}
                    <motion.div className="bento-card hero-photo" {...fadeUp(0.45)}>
                        <img
                            src="/nanda.webp"
                            alt="Nanda"
                            onError={(e) => { e.target.src = '/priyoga.webp'; }}
                        />
                    </motion.div>

                    {/* Status Card */}
                    <motion.div className="bento-card hero-info" {...fadeUp(0.5)}>
                        <div className="info-block">
                            <span className="info-label">Currently</span>
                            <span className="info-value">
                                <span className="status-dot" /> Studying & Building
                            </span>
                        </div>
                        <div className="info-block">
                            <span className="info-label">Based in</span>
                            <span className="info-value">Sidoarjo, East Java</span>
                        </div>
                    </motion.div>

                    {/* Time Card */}
                    <motion.div className="bento-card hero-time" {...fadeUp(0.55)}>
                        <span className="info-label">Local Time (WIB)</span>
                        <span className="time-display mono">{time}</span>
                        <span className="info-label" style={{ marginTop: 'auto' }}>Education</span>
                        <span className="info-value">UPN Veteran Jawa Timur</span>
                    </motion.div>

                    {/* Tech Card */}
                    <motion.div className="bento-card hero-tech" {...fadeUp(0.6)}>
                        <span className="info-label">Tech Stack</span>
                        <div className="tech-icons">
                            {techIcons.map((t, i) => (
                                <motion.img
                                    key={i}
                                    src={t.src}
                                    alt={t.alt}
                                    whileHover={{ y: -3, scale: 1.1 }}
                                    transition={{ type: 'spring', stiffness: 300 }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
